// extracted by mini-css-extract-plugin
module.exports = {"lia-box":"SurveyPromptFloatingBox_lia-box__1LaKI","liaSurveyBoxPulse":"SurveyPromptFloatingBox_liaSurveyBoxPulse__GvCqy"};